import { PLANS, PLANS_CURRENT, PLANS_SUBSCRIBE } from "../configs/routes.js";
import api from "./api.js";

export const getPlans = () =>
    new Promise((resolve, reject) => {
        api
            .get(PLANS, { timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });

export const getCurrentPlan = () =>
    new Promise((resolve, reject) => {
        api
            .get(PLANS_CURRENT, { timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });

export const subscribePlan = (planId) =>
    new Promise((resolve, reject) => {
        api
            .post(PLANS_SUBSCRIBE, { plan_id: planId }, { timeout: 60000 })
            .then((response) => resolve(response.data ?? null))
            .catch((err) => reject(err));
    });
